import { useEffect, useState } from 'react';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import { useSelector } from 'react-redux';
import organizationEventEmitter from '../../../../../utilities/organizationEmmiter';
import { Select, Badge } from 'antd';

const OrganizationFilter = () => {
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const [organizationDropdown, setOrganizationDropdown] = useState([]);
  const { getActiveOrganizationsList } = useSelector(
    (state) => state?.organizationState
  );

  const [selectedOrganizationGlobal, setSelectedOrganizationGlobal] = useState(
    () => {
      const savedOrg = getFromStorage('superAdminSelectedOrganization');
      if (savedOrg) {
        return JSON.parse(savedOrg);
      } else {
        const initialOrg = {
          value: currentPractitioner.org_id,
          label: currentPractitioner.org_name,
          org_uuid: currentPractitioner.org_uuid,
        };
        storeInLocal(
          'superAdminSelectedOrganization',
          JSON.stringify(initialOrg)
        );
        return initialOrg;
      }
    }
  );

  useEffect(() => {
    if (
      getActiveOrganizationsList &&
      Array.isArray(getActiveOrganizationsList)
    ) {
      let dataArr = [];
      getActiveOrganizationsList.forEach((key) => {
        dataArr.push({
          value: key?.org_id,
          label: key?.org_name,
          displayLabel: (
            <>
              <Badge
                count={key?.user_count} // assuming `badgeCount` exists in the data
                overflowCount={99}
                offset={[20, 7]}
                style={{ backgroundColor: '#52c41a' }} // adjust badge style if needed
                className="mr-2"
                showZero={true}
              >
                <span>{key?.org_name}</span>
              </Badge>
            </>
          ),
          org_uuid: key?.org_uuid,
        });
      });
      setOrganizationDropdown(dataArr);
    }
  }, [getActiveOrganizationsList]);
  useEffect(() => {
    const handleStorageChange = () => {
      const savedOrg = getFromStorage('superAdminSelectedOrganization');
      setSelectedOrganizationGlobal(savedOrg ? JSON.parse(savedOrg) : null);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleOrganizationSelect = (value) => {
    const selectedOrg = organizationDropdown.find((org) => org.value === value);
    setSelectedOrganizationGlobal(selectedOrg);
    storeInLocal('superAdminSelectedOrganization', JSON.stringify(selectedOrg));
    organizationEventEmitter.dispatch('organizationChanged', selectedOrg);
  };

  return (
    <div className="-ml-3">
      <div
        id="search_org"
        className="bg-white shadow-sm rounded-xl w-[32rem] flex items-center ml-4"
      >
        <Select
          style={{
            placeholder: {
              fontFamily: 'Poppins',
              color: '#667085',
            },
          }}
          bordered={false}
          className="border-none font-sans h-10 flex items-center  focus:outline-none w-full"
          optionFilterProp="children"
          placeholder="Search organization"
          showSearch
          options={organizationDropdown.map((item) => ({
            value: item.value,
            label: item.displayLabel, // Use the plain text label for searching
            children: item.label, // Custom JSX label for display
          }))}
          value={selectedOrganizationGlobal?.value}
          id="search_org"
          onChange={(e) => handleOrganizationSelect(e)}
        ></Select>
      </div>
    </div>
  );
};

export default OrganizationFilter;
